// This import loads the firebase namespace along with all its type information.
import CoherentScreen from './coherent-screen-model'

export async function load_coherentScreens(): Promise<CoherentScreen[]> {
  throw 'Not implemented'
}

export async function delete_coherentScreen(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_coherentScreen(): Promise<CoherentScreen> {
  throw 'Not implemented'
}
